import {Injectable} from '@angular/core';
export class EndpointConfig {
    baseUri: string = '';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function EndpointConfig_tsickle_Closure_declarations() {
/** @type {?} */
EndpointConfig.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EndpointConfig.ctorParameters;
/** @type {?} */
EndpointConfig.prototype.baseUri;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
